import * as React from "react";
const SvgArrowDownFilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 8L9.33013 0.5H0.669873L5 8Z", fill: "#686868" }));
export default SvgArrowDownFilled;
